<template>
    <v-dialog width="600px" v-model="isOpenCredentialsView">
        <v-card elevation="4">
            <v-card-title primary-title>
                <v-row>
                    <v-col cols="12" align="start">
                        <div
                            v-if="$vuetify.breakpoint.mdAndDown"
                            class="primary--text text-overline text-center"
                        >
                            {{ type == 'CREATE' ? 'Creando' : 'Editando' }}
                            Credenciales
                        </div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h5 text-capitalize
                                mt-n1
                            "
                        >
                            <v-icon large> mdi-key-variant </v-icon>
                            {{ type == 'CREATE' ? 'Creando' : 'Editando' }}
                            Credenciales
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-row dense>
                    <v-col cols="12" md="12" class="px-1">
                        <v-card outlined>
                            <v-row class="my-1 mx-1">
                                <h4
                                    class="font-weight-light primary--text px-2"
                                >
                                    Nombre del Portal
                                </h4>
                            </v-row>
                            <v-divider class="mx-1"></v-divider>
                            <v-row no-gutters>
                                <v-text-field
                                    class="mx-4"
                                    v-model="form.nombre_portal"
                                    prepend-icon="mdi-form-textbox"
                                    label="nombre"
                                ></v-text-field>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="12" class="px-1">
                        <v-card outlined>
                            <v-row class="my-1 mx-1">
                                <h4
                                    class="font-weight-light primary--text px-2"
                                >
                                    URL
                                </h4>
                            </v-row>
                            <v-divider class="mx-1"></v-divider>
                            <v-row no-gutters>
                                <v-text-field
                                    class="mx-4"
                                    v-model="form.url"
                                    prepend-icon="mdi-link"
                                    label="url"
                                ></v-text-field>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="12" class="px-1">
                        <v-card outlined>
                            <v-row class="my-1 mx-1">
                                <h4
                                    class="font-weight-light primary--text px-2"
                                >
                                    Usuario
                                </h4>
                            </v-row>
                            <v-divider class="mx-1"></v-divider>
                            <v-row no-gutters>
                                <v-text-field
                                    class="mx-4"
                                    v-model="form.username"
                                    prepend-icon="mdi-account-outline"
                                    label="username"
                                ></v-text-field>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="12" class="px-1">
                        <v-card outlined>
                            <v-row class="my-1 mx-1">
                                <h4
                                    class="font-weight-light primary--text px-2"
                                >
                                    Contraseña
                                </h4>
                            </v-row>
                            <v-divider class="mx-1"></v-divider>
                            <v-row no-gutters>
                                <v-text-field
                                    class="mx-4"
                                    v-model="form.password"
                                    prepend-icon="mdi-lock-outline"
                                    label="password"
                                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="show1 ? 'text' : 'password'"
                                    name="input-10-1"
                                    counter
                                    @click:append="show1 = !show1"
                            ></v-text-field>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="12" class="px-1">
                        <v-card outlined>
                            <v-row class="my-1 mx-1">
                                <h4
                                    class="font-weight-light primary--text px-2"
                                >
                                    Cookie
                                </h4>
                            </v-row>
                            <v-divider class="mx-1"></v-divider>
                            <v-row no-gutters>
                                <v-textarea
                                    prepend-icon="mdi-cookie-outline"
                                    class="mx-4"
                                    v-model="form.cookie"
                                    clearable
                                    clear-icon="mdi-close-circle"
                                    label="Cookie"
                                    persistent-hint
                                    hint="Recuerde incluir las llaves!"
                                ></v-textarea>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions class="justify-end pt-3">
                <v-btn
                    :disabled="!checkSubmitDisabled"
                    color="success"
                    @click="
                        submit();
                        close();
                    "
                >
                    {{ type == 'CREATE' ? 'Crear' : 'Editar' }}
                </v-btn>
                <v-btn text color="red" @click="close()"> Cerrar </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import defaultCredentialsForm from '@/util/rrhh/defaultCredentialsForm.js';
import { clone } from '@/util/libUtil.js';

export default {
    name: 'CredentialsForm',
    data: () => ({
        show1: false,
    }),
    methods: {
        close() {
            this.form = clone(defaultCredentialsForm);
            this.isOpenCredentialsView = false;
        },
        submit() {
            // replace simple quotes with double quotes
            if (this.form.cookie) {
                this.form.cookie = this.form.cookie.replace(/'/g, '"');
                this.form.cookie = JSON.parse(this.form.cookie);
            }
            
            if(this.type == 'CREATE')
                this.createCredentials();
            else
                this.updateCredentials();
        },
        ...mapActions('rrhh', ['createCredentials', 'updateCredentials']),
    },
    computed: {
        checkSubmitDisabled() {
            return (
                Boolean(this.form.nombre_portal) &&
                Boolean(this.form.url) &&
                Boolean(this.form.username)
            );
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        form: {
            get() {
                return this.$store.state.rrhh.credentials.form;
            },
            set(value) {
                this.$store.commit('rrhh/credentialsForm', value);
            },
        },
        isOpenCredentialsView: {
            get() {
                let isOpen =
                    this.$store.state.rrhh.credentials.isOpenCredentialsView;
                if (!isOpen) this.form = clone(defaultCredentialsForm);

                return isOpen;
            },
            set(value) {
                this.$store.commit('rrhh/isOpenCredentialsView', value);
            },
        },
        ...mapState('rrhh', {
            type: (state) => state.credentials.type,
        }),
        ...mapState('util', {
            exportingProgress: (state) => state.exportingProgress,
            isExporting: (state) => state.isExporting,
        }),
    },
};
</script>

<style scoped>
.wrapper {
    width: 28px;
    margin-left: 30px;
}

.checkmark {
    stroke: green;
    stroke-dashoffset: 745.74853515625;
    stroke-dasharray: 745.74853515625;
    animation: dash 2s ease-out forwards;
}

@keyframes dash {
    0% {
        -dashoffset: 745.74853515625;
    }
    100% {
        stroke-dashoffset: 0;
    }
}
</style>